var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sign-page',{attrs:{"title-text":"岗位晋升预警","request":_vm.request,"column-list":_vm.columns,"table-size":"large","titleMenus":[],"tableActions":[],"need-data-file":true},on:{"tableAction":_vm.tableAction}})}
var staticRenderFns = []

export { render, staticRenderFns }